import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import IntroAnimation from './components/IntroAnimation'

function App() {
  return (
    <>
      <IntroAnimation />
      <div className="grain-overlay" />
      <RouterProvider router={router} />
    </>
  )
}

export default App
